import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LocationSearch } from '../types/quick-search.type';

@Injectable({
    providedIn: 'root',
})
export class QuickSearchService {
    private searchLocationsSubject = new BehaviorSubject<LocationSearch[]>([]);
    private dropdownOpenSubject = new Subject<boolean>();
    private resetFiltersSubject = new Subject<void>();
    private saveSearchSubject = new Subject<void>();
    public dropdownOpen$ = this.dropdownOpenSubject.asObservable();
    public searchLocationUpdate = new Subject<{
        type: `add` | `remove`;
        location: LocationSearch | null;
        index?: number;
    }>();
    searchLocations$: Observable<LocationSearch[]> = this.searchLocationsSubject.asObservable();

    /**
     * To notify filter reset
     */
    public resetFilters = this.resetFiltersSubject.asObservable();

    /**
     * TO notify save search
     */
    public saveSearch = this.saveSearchSubject.asObservable();

    updateSearchLocations(locations: LocationSearch[]): void {
        this.searchLocationsSubject.next(locations);
    }

    addSearchLocation(location: LocationSearch): void {
        const currentLocations = this.searchLocationsSubject.getValue();
        this.searchLocationsSubject.next([...currentLocations, location]);
        this.searchLocationUpdate.next({ type: `add`, location });
    }

    removeSearchLocation(index: number): void {
        const currentLocations = this.searchLocationsSubject.getValue();
        const updatedLocations = currentLocations.filter((_, i) => i !== index);
        this.searchLocationsSubject.next(updatedLocations);
        this.searchLocationUpdate.next({ type: `remove`, location: null, index });
    }

    getCurrentSearchLocations(): LocationSearch[] {
        return this.searchLocationsSubject.getValue();
    }

    //to toggle the site logo in mobile ui when dropdown opens
    setDropdownState(isOpen: boolean) {
        this.dropdownOpenSubject.next(isOpen);
    }

    /**
     * Trigger a filter reset
     */
    triggerFilterReset() {
        this.resetFiltersSubject.next();
    }

    /**
     * Trigger a search save
     */
    triggerSaveSearch() {
        this.saveSearchSubject.next();
    }
}
